import User from '@/models/User'
import Api from '@/api'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    detailedList: [],
    listMeta: {},
    userDetails: null,
    hide: [
      'email_verified_at',
      'primary_username',
      'description',
      'phone_number_verified_at',
      'created_at',
      'updated_at',
      'blocked_at',
      'subscription_status',
      'done_trial',
      'is_subscribed',
      'subscribed_platform',
      'email_verified',
      'phone_number_verified',
      'verified',
      'mine',
      'has_password',
      'has_pincode',
      'user_type',
      'company_join_invitations',
      'has_answered_questions_1',
      'avatar_permanent_thumb_url',
      'avatar_permanent_url',
      'profile_photo',
      'created_via',
      // 'id',
    ],
  },

  getters: {
    users(state) {
      return state.list
    },

    detailedUsers(state) {
      return state.detailedList
    },

    usersMeta(state) {
      return state.listMeta
    },
  },

  mutations: {
    setUserList(state, users) {
      state.list = map(users, (user) => {
        if (user instanceof User) {
          return user
        } else {
          return new User(user)
        }
      })
    },

    setUserDetailedList(state, users) {
      const prettify = (s) =>
        s
          .replace(/_/g, ' ') // underscores → spaces
          .toLowerCase() // normalize
          .replace(/\b\w/g, (c) => c.toUpperCase()) // cap each word

      state.detailedList = map(users, (user) => {
        if (user instanceof User) {
          const filteredEntries = Object.entries(user).filter(
            ([k]) => !state.hide.includes(k),
          )
          const prettifiedUser = {}
          for (const [key, value] of filteredEntries) {
            prettifiedUser[prettify(key)] = value
          }
          // ShareTradiesModal reads user.excluded.personal_info on every
          // render pass. Seeding it here (present the moment this object
          // becomes reactive) closes the gap between this commit and the
          // component's own $set() call in fetchSelectedTradiesFullData,
          // which otherwise leaves a render frame where 'excluded' doesn't
          // exist yet and crashes the modal.
          prettifiedUser.excluded = {
            id: user.Id,
            files: [],
            personal_info: [],
          }

          return prettifiedUser
        } else {
          return new User(user)
        }
      })
    },

    setUserListMeta(state, meta) {
      state.listMeta = meta
    },

    setUserDetails(state, user) {
      if (user instanceof User) {
        state.userDetails = user
      } else {
        state.userDetails = new User(user)
      }
    },

    clearUserDetails(state) {
      state.userDetails = null
    },
  },

  actions: {
    async getUsers({ commit }, params) {
      const query = User.page(params.page || 1).limit(params.limit || 10)
      query.where('search', params.search || null)
      query.where('user_type', params.userType || null)
      query.where('project_id', params.projectId || null)
      query.where('user_ids', params.userIds || null)

      const res = await query.get()
      if (params.userIds) {
        commit('setUserDetailedList', res.data)
        return
      }
      commit('setUserList', res.data)
      commit('setUserListMeta', res.meta)
    },

    async getUserDetails({ commit }, id) {
      const { data } = await Api.get(`users/${id}`)
      commit('setUserDetails', data.data)
    },
  },
}
